import { trackEvent } from '@src/services/analytics';

export const onFocus = (page, query) => {
	trackEvent('SearchFocused', {
		searchState: {
			pageNumber: page + 1,
		},
		typedTerm: query,
	});
};

export const onModalClose = () => {
	const detachedModal = document.getElementsByClassName('aa-Detached');
	if (detachedModal.length > 0) {
		detachedModal[0].classList.remove('aa-Detached');
	}
};
